import { render, staticRenderFns } from "./LiquidacionAgenciaPage.vue?vue&type=template&id=000403b7&scoped=true"
import script from "./LiquidacionAgenciaPage.vue?vue&type=script&lang=js"
export * from "./LiquidacionAgenciaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000403b7",
  null
  
)

export default component.exports